module.exports = __webpack_public_path__ + "static/media/playfulbet-mobile.81ef40e1.jpg";